/**
 * Строит query-string из `Record<string, unknown>`, пропуская undefined/null/''.
 * Возвращает пустую строку (не `?`), если все значения пустые —
 * удобно конкатенировать с base URL: `${BASE}${buildQuery(params)}`.
 *
 * Массивы и объекты сериализуются через `String(v)` — для большинства AB3
 * API этого достаточно; если нужен повторяющийся ключ (`?tags=a&tags=b`),
 * сформируй строку вручную в конкретном сервисе.
 */
export function buildQuery(params: object): string {
  const query = Object.entries(params as Record<string, unknown>)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`)
    .join('&');
  return query ? `?${query}` : '';
}
